import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ExecucaoOrcamentaria } from '../../models/execucao-orcamentaria.model';
import { ExecucaoOrcamentariaService } from '../../services/execucao-orcamentaria.service';

@Component({
  selector: 'app-detalhe-execucao-orcamentaria-list',
  templateUrl: './detalhe-execucao-orcamentaria-list.component.html',
  styleUrls: ['./detalhe-execucao-orcamentaria-list.component.scss']
})
export class DetalheExecucaoOrcamentariaListComponent extends BaseListComponent<ExecucaoOrcamentaria> implements OnInit, OnDestroy {

  @Input() idEntrega: number;
  @Input() idIndicador: number;
  execucaoList: ExecucaoOrcamentaria[];
  execucao: any;
  months: any;
  permission: any;

  constructor(
    private myService: ExecucaoOrcamentariaService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.initList();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initList() {
    if (this.idEntrega) {
      this.addSub(
        this.myService.getEntregasList(this.idEntrega).subscribe({
          next: (res) => {
            this.execucaoList = res['list'];
            this.permission = res['permission'];
            this.execucao = res['execucao'];
            this.months = res['months'];
            this.loaded();
          },
          error: (err) => {
            this.loaded();
          },
        })
      );
    } else if (this.idIndicador) {
      this.addSub(
        this.myService.getIndicadoresList(this.idIndicador).subscribe({
          next: (res) => {
            this.execucaoList = res['list'];
            this.permission = res['permission'];
            this.execucao = res['execucao'];
            this.months = res['months'];
            this.loaded();
          },
          error: (err) => {
            this.loaded();
          },
        })
      );
    }
  }

  view(value) {
    const foundItem = this.execucaoList.find((item) => (item.budget_active = item.budget_assoc_id === value?.budget_assoc_id));
    this.execucaoList.forEach((item) => (item.budget_active = item === foundItem));
  }

  monthExecution(month, data){
    const atrib = data?.execucao_orcamentaria_atribuicao?.[0];
    return atrib?.execucao_orcamentaria_resultados_totais?.find(d => d?.mes == month) ?? [];
  }

  monthExecutionManual(data){
    const atrib = data?.execucao_orcamentaria_atribuicao?.[0];
    return atrib?.execucao_orcamentaria_gastos_manuais ?? [];
  }
}
